import "./App.css";
import Sidebar from "./sidebar/sidebar.js";
import MainBody from "./mainbody/mainbody.js";
import { useState, useEffect } from "react";

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [chatHistory, setChatHistory] = useState([]);
  const [currentChatId, setCurrentChatId] = useState(null);

  // Update `isMobile` state based on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNewChat = () => {
    const newChatId = Date.now();
    const newChat = {
      id: newChatId,
      title: "New Chat",
      timestamp: new Date().toISOString(),
      messages: []
    };
    setChatHistory(prev => [...prev, newChat]);
    setCurrentChatId(newChatId);
    if (isMobile) {
      setIsSidebarOpen(false);
    }
    return newChatId;
  };

  const updateChatMessages = (chatId, messages) => {
    setChatHistory(prev => prev.map(chat => {
      if (chat.id === chatId) {
        return { ...chat, messages };
      }
      return chat;
    }));
  };

  const updateChatTitle = (chatId, firstMessage) => {
    setChatHistory(prev => prev.map(chat => {
      if (chat.id === chatId) {
        const title = firstMessage.length > 30
          ? firstMessage.substring(0, 30) + "..."
          : firstMessage;
        return { ...chat, title };
      }
      return chat;
    }));
  };

  const handleSelectChat = (chatId) => {
    setCurrentChatId(chatId);
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className="App">
      <div className={`sidebar-overlay ${isSidebarOpen ? "visible" : ""}`}>
        <Sidebar
          onClose={() => setIsSidebarOpen(false)}
          onNewChat={handleNewChat}
          chatHistory={chatHistory}
          onSelectChat={handleSelectChat}
        />
      </div>
      <MainBody
        onMenuClick={() => {
          if (isMobile) {
            setIsSidebarOpen(!isSidebarOpen);
          }
        }}
        currentChatId={currentChatId}
        onUpdateChatTitle={updateChatTitle}
        onUpdateMessages={updateChatMessages}
        currentChat={chatHistory.find(chat => chat.id === currentChatId)}
        onNewChat={handleNewChat}
      />
    </div>
  );
}

export default App;
